import { Alert } from "@/store/types";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class AlertMessage extends Vue {
  @Prop(Object)
  alert!: Alert;

  get alertMessage() {
    return this.alert != null && this.alert.message != null
      ? this.alert.message.replace("|", "</br >").split("^^")[0]
      : "";
  }
}
